import { PluginHelper } from "./PluginHelper";
import { removeViewLevelFromCell, removeViewLevelProperties, } from "./removeViewLevelProperties";
export function getVisibleLayout(layout, nextViewLevel) {
    return {
        id: layout.id,
        version: layout.version,
        rows: layout.rows
            .filter((row) => hasVisibleViewLevels(row.viewLevels, nextViewLevel))
            .map((row) => getVisibleRows(row, nextViewLevel)),
    };
}
function getVisibleRows(row, nextViewLevel) {
    return removeViewLevelProperties(Object.assign(Object.assign({}, row), { cells: row.cells
            .filter((cell) => hasVisibleViewLevels(cell.viewLevels, nextViewLevel))
            .map((cell) => getVisibleCells(cell, nextViewLevel)) }));
}
function getVisibleCells(cell, nextViewLevel) {
    // we render everything below attributes
    if (PluginHelper.isAttributePlugin(cell)) {
        return removeViewLevelFromCell(cell);
    }
    return removeViewLevelProperties(Object.assign(Object.assign({}, cell), { rows: cell.rows
            .filter((row) => hasVisibleViewLevels(row.viewLevels, nextViewLevel))
            .map((row) => getVisibleRows(row, nextViewLevel)) }));
}
function hasVisibleViewLevels(viewLevels, nextViewLevel) {
    const levels = Array.from(viewLevels);
    return levels.some((level) => level > 0 && level <= nextViewLevel);
}
//# sourceMappingURL=getVisibleLayout.js.map